/** Set when someone signs in as an operator so the AB test menu is still reachable once they log out */
const AB_TEST_MENU_KEY = 'showAbTestMenu';

export const hasAbTestMenuFlag = () => {
  try {
    return localStorage.getItem(AB_TEST_MENU_KEY) === 'true';
  } catch {
    return false;
  }
};

export const setAbTestMenuFlag = () => {
  try {
    localStorage.setItem(AB_TEST_MENU_KEY, 'true');
  } catch {
    // Private browsing can block writes, in which case the menu just will not persist
  }
};

export const clearAbTestMenuFlag = () => {
  try {
    localStorage.removeItem(AB_TEST_MENU_KEY);
  } catch {
    // Nothing to do, the flag was never stored
  }
};
